var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetweetslarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.42 12.22a.76.76 0 0 1-.75-.75V8.15a2.25 2.25 0 0 0-2.25-2.25H3.58a.76.76 0 0 1-.75-.75c0-.41.34-.75.75-.75h13.84a3.75 3.75 0 0 1 3.75 3.75v3.32c0 .42-.34.75-.75.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74 9.07a.74.74 0 0 1-.53-.22L3.05 5.69a.75.75 0 0 1 0-1.06l3.16-3.16a.75.75 0 0 1 1.06 0c.29.29.29.77 0 1.06L4.64 5.16l2.63 2.63c.29.29.29.77 0 1.06a.79.79 0 0 1-.53.22ZM20.42 19.59H6.58a3.75 3.75 0 0 1-3.75-3.75v-3.32c0-.41.34-.75.75-.75s.75.34.75.75v3.32a2.25 2.25 0 0 0 2.25 2.25h13.84c.41 0 .75.34.75.75s-.34.75-.75.75Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.26 22.75a.74.74 0 0 1-.53-.22.75.75 0 0 1 0-1.06l2.63-2.63-2.63-2.63a.75.75 0 0 1 0-1.06.75.75 0 0 1 1.06 0l3.16 3.16a.75.75 0 0 1 0 1.06l-3.16 3.16a.71.71 0 0 1-.53.22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetweetslarge);
export default __webpack_public_path__ + "static/media/retweets.large.fb98ee3d22635ad8f97fe2caf55a7d6c.svg";
export { ForwardRef as ReactComponent };